import type { SVGProps } from 'react';

const SvgSaveLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M16.5 20V14.5C16.5 13.9477 16.0523 13.5 15.5 13.5H8.5C7.94772 13.5 7.5 13.9477 7.5 14.5V20M9 7H14M16.0858 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V7.91421C20 7.649 19.8946 7.39464 19.7071 7.20711L16.7929 4.29289C16.6054 4.10536 16.351 4 16.0858 4Z'
      stroke='currentColor'
      strokeLinecap='round'
    />
  </svg>
);
export default SvgSaveLt;
